import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpEventType, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { GetMedialModel, MediaModel } from '../model/media.model';
import { BehaviorSubject, filter, map, Observable, Observer, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  constructor(private _httpClient: HttpClient,private zone: NgZone) {}
  apiUrl = environment.apiUrl + 'media';
  private mediaCache = new Map<string, { data: MediaModel; expiry: number }>();
  // uploadMedia(file: any) {
  //   const formData = new FormData();
  //   formData.append('media', file, file.name);
  //   return this._httpClient.post<MediaModel>(
  //     this.apiUrl + '/upload',
  //     formData,
  //     {
  //       reportProgress: true,
  //     }
  //   );
  // }
  getMediaUrls(fileNames: string, source: string = 'S3') {
    const encodedName = encodeURIComponent(fileNames);
    return this._httpClient.get<GetMedialModel[]>(
      this.apiUrl + '/url/' + encodedName + '?source=' + source
    );
  }
  // uploadMediaToS3(url: string, file: Blob) {
  //   return this._httpClient.put(url, file, {
  //     headers: {
  //       'Content-Type': file.type,
  //     },
  //   });
  // }

  uploadMediaToS3(url: string, file: Blob) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': file.type,
      }),
    };
    return this._httpClient.put(url, file, httpOptions);
  }

  // uploadToGCSWithProgress(url: string, file: Blob): Observable<number> {
  //   return new Observable((observer) => {
  //     this.zone.runOutsideAngular(() => {
  //       const xhr = new XMLHttpRequest();
  //       xhr.open('PUT', url, true);
  //       xhr.setRequestHeader('Cache-Control', 'no-store');
  //       console.log("XHR: ==>", xhr);
  //       xhr.onreadystatechange = (e) => {
  //         console.log("ReadyState:",e);
  //         console.log("XHRStatus:", xhr.status);
  //         console.log("ReadyState:", xhr.readyState);
  //       }
  //       xhr.upload.onprogress = (event) => {
  //         console.log("LengthComputable:"+ event.lengthComputable);
  //         this.zone.run(() => {
  //           if (event.lengthComputable) {
  //             const progress = Math.round((event.loaded / event.total) * 100);
  //             observer.next(progress);
  //           }
  //         });
  //       };
  
  //       xhr.onload = () => {
  //         if (xhr.status === 200) {
  //           this.zone.run(() => observer.complete());
  //         } else {
  //           this.zone.run(() => observer.error(`Failed with status ${xhr.status}`));
  //         }
  //       };
  
  //       xhr.onerror = () => {
  //         this.zone.run(() => observer.error('An error occurred during the upload.'));
  //       };
  //       xhr.send(file);
  //     });
  //   });
  // }
   /**
     * @dynamic
     * This block handles upload progress and should not be optimized.
    */
   uploadToGCSWithProgress(url: string, file: Blob): Observable<number> {
    return new Observable((observer: Observer<number>) => {
      this.zone.runOutsideAngular(() => {
        const xhr = new XMLHttpRequest();
        
        // Cleanup function to avoid memory leaks
        const cleanup = () => {
          xhr.upload.onprogress = null;
          xhr.onload = null;
          xhr.onerror = null;
          xhr.onabort = null;
        };
  
        try {
          xhr.open('PUT', url, true);
          
          // Set Content-Type header safely
          const mimeType = file.type || 'application/octet-stream';
          xhr.setRequestHeader('Content-Type', mimeType);
  
          // Progress handler
          xhr.upload.onprogress = (event: ProgressEvent) => {
            this.zone.run(() => {
              if (event.lengthComputable) {
                const progress = Math.round((event.loaded / event.total) * 100);
                observer.next(progress);
              }
              // Still notify even if length isn't computable
              else {
                observer.next(-1); // Indeterminate progress
              }
            });
          };
  
          // Success handler
          xhr.onload = () => {
            cleanup();
            this.zone.run(() => {
              // Accept all 2xx status codes
              if (xhr.status >= 200 && xhr.status < 300) {
                observer.complete();
              } else {
                observer.error(
                  `Upload failed with status ${xhr.status}: ${xhr.statusText}`
                );
              }
            });
          };
  
          // Error handler
          xhr.onerror = () => {
            cleanup();
            this.zone.run(() => {
              observer.error(
                `Network error: ${xhr.statusText || 'Unknown error'}`
              );
            });
          };
  
          // Abort handler
          xhr.onabort = () => {
            cleanup();
            this.zone.run(() => {
              observer.error('Upload canceled by user');
            });
          };
  
          xhr.send(file);
  
        } catch (error) {
          this.zone.run(() => {
            observer.error(`Request initialization failed: ${error}`);
          });
          return;
        }
  
        // Teardown logic
        return () => {
          if (xhr.readyState !== XMLHttpRequest.DONE) {
            xhr.abort();
          }
          cleanup();
        };
      });
    });
  }
  getMediaUrlsByToken(token: string, fileNames: string) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json', // Optional: specify the content type
      'skip-interceptor': 'true', // Custom flag to skip token interceptor
    });
    return this._httpClient.get<GetMedialModel[]>(
      this.apiUrl + '/url/' + fileNames,
      { headers }
    );
  }

  // getMedia(ids: string[]){
  //   return this._httpClient.get<MediaModel[]>(`${environment.apiUrl}media/get/${ids.join(',')}`);
  // }

  getMedia(ids: string[]): Observable<MediaModel[]> {
    const now = Date.now();
    // console.log("Converted to IST:", new Date(Date.now()).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }));
    const cachedMedia: MediaModel[] = [];
    const idsToFetch: string[] = [];

    ids.forEach((id) => {
      const cached = this.mediaCache.get(id);
      if (cached && cached.expiry){
        // console.log("cached Expiry:", new Date(cached.expiry).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }));
      }      
      if (cached && cached.expiry > now) {
        // If cached item is still valid, add it to cachedMedia array
        cachedMedia.push(cached.data);
      } else {
        // If not cached or expired, add to idsToFetch for a new API call
        idsToFetch.push(id);
      }
    });

    if (idsToFetch.length === 0) {
      // All items are cached and valid
      return of(cachedMedia);
    } else {
      // Fetch the missing items
      return this._httpClient
        .get<MediaModel[]>(
          `${environment.apiUrl}media/get/${idsToFetch.join(',')}`
        )
        .pipe(
          map((response) => {
            // Cache each fetched item with an expiry time of 1 hour
            response.forEach((item) => {
              this.mediaCache.set(item.id, {
                data: item,
                expiry: now + 60 * 60 * 1000,
              });
            });
            return [...cachedMedia, ...response];
          })
        );
    }
  }
}
